import React from 'react'
import './styles.scss'
import { UserAvatar } from 'components/common'
import { getStaticImage } from 'utils/statics'

const MenuMentions = ({ operators, handlePressOperator, operatorsSelected }) => {

  const selectedOperators = (operator) => {
    const exist = operatorsSelected.some(op => op._id === operator._id)
    const newOperatorsSelected = [...operatorsSelected]
    if(!exist){
      newOperatorsSelected.push(operator)
    }
    handlePressOperator(newOperatorsSelected)
  }

  const textName = (name, lastname, id) => {
    if(name || lastname) return `${name || ''} ${lastname || ''}`
    return id
  }

  return (
    <div className='menu-mentions-container'>
      {operators.map(operator => (
        <div
          key={operator._id}
          className='menu-mentions-container__card'
          onClick={() => selectedOperators(operator)}
        >
          <UserAvatar
            key={operator._id}
            avatar={operator.picture}
            onErrorAvatar={event => {
              event.target.src = getStaticImage('/icons/orange-brand/icon-avatar.svg')
              event.onerror = null
            }}
            avatarHeight={40}
            avatarWidth={40}
          />
          <div className='menu-mentions-container__card-text'>

            <span className='menu-mentions-container__card-text--title text-ellipsis'>{textName(operator.name, operator.lastname, operator._id)}</span>
            <span className='menu-mentions-container__card-text--subtitle text-ellipsis'>{operator.departament || ''}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

export default MenuMentions